import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import MainPage from '../pages/MainPage';
import DoctorMainPage from '../pages/DoctorMainPage';
import Signup from '../pages/Signup';
import ControlCenter from '../pages/ControlCenter';
import GuardianControlCenter from '../pages/GuardianControlCenter';
import Dashboard from '../pages/Dashboard';
import DashboardDetail from '../pages/DashboardDetail';
import VitalsDetail from '../pages/VitalsDetail';
import MessageManagement from '../pages/MessageManagement';
import Operations from '../pages/Operations';
import Inquiry from '../pages/Inquiry';
import MessageApproval from '../pages/MessageApproval';
import AdminGroups from '../pages/AdminGroups';
import AdminApprovals from '../pages/AdminApprovals';
import SuperAdminRoute from './SuperAdminRoute';
import AdminScreens from '../pages/AdminScreens';
import UserGroups from '../pages/UserGroups';
import DoctorManagement from '../pages/DoctorManagement';
import DoctorApplications from '../pages/DoctorApplications';
import TeleMedicine from '../pages/TeleMedicine';
import TeleMedicineVideo from '../pages/TeleMedicineVideo';
import KcbAuthResult from '../pages/KcbAuthResult';
import RaonAuthResult from '../pages/RaonAuthResult';
import SafePackageList from '../pages/SafePackageList';
import UserWithdrawManagement from '../pages/UserWithdrawManagement';
import HospitalManagement from '../pages/HospitalManagement';
import GroupReportOps from '../pages/GroupReportOps';
import PushAnnouncements from '../pages/PushAnnouncements';
import HealthReport from '../pages/HealthReport';
import CarePlan from '../pages/CarePlan';
import Survey from '../pages/Survey';
import TermsOfService from '../pages/TermsOfService';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import RefundPolicy from '../pages/RefundPolicy';
import CertSelect from '../pages/CertSelect';
import KcbPopup from '../pages/KcbPopup';
import RaonPopup from '../pages/RaonPopup';
import ComparisonChartDemo from '../pages/ComparisonChartDemo';
import PackagePurchaseManagement from '../pages/PackagePurchaseManagement';
import UserChat from '../pages/UserChat';

//import AdminGroupsDetail from '../pages/AdminGroupsDetail';


export default function Router() {
    return (
        <Routes>
            <Route path="/" element={<DoctorMainPage />} />   {/** 주치의 로그인 페이지 */}
            <Route path="/login" element={<DoctorMainPage />} />   {/** 주치의 로그인 페이지 */}
            <Route path="/doctor" element={<DoctorMainPage />} />   {/** 주치의 로그인 페이지 */}
            {/** 보호자 로그인 페이지. 원래 / 와 /login 이었는데 2026-02-10 (2d34813)
                 에 주치의 로그인이 그 자리를 가져가면서 경로가 사라졌다 — import 만
                 남아 화면에 닿을 방법이 없었다. / 를 되돌리면 주치의가 막히므로
                 /doctor 와 짝이 되는 /guardian 으로 다시 연결한다. */}
            <Route path="/guardian" element={<MainPage />} />
            <Route path="/signup" element={<Signup />} /> {/** 회원가입 페이지 경로 수정 */}
            <Route path="/ControlCenter" element={<ControlCenter />} />
            <Route path="/GuardianControlCenter" element={<GuardianControlCenter />} />
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/DashboardDetail/:id" element={<DashboardDetail />} />
            <Route path="/DashboardDetail/:id/records" element={<DashboardDetail />} />
            <Route path="/DashboardDetail/:id/frail" element={<DashboardDetail />} />
            <Route path="/VitalsDetail/:appUserId" element={<VitalsDetail />} />  {/** 스마트링 바이탈 상세 */}
            <Route path="/MessageManagement" element={<MessageManagement />} /> {/** 메세지 관리 페이지 경로 수정 */}
            <Route path="/Operations" element={<SuperAdminRoute><Operations /></SuperAdminRoute>} /> {/** 관리자 관리. 2026-09-16 최고관리자 전용 */}
            <Route path="/Inquiry" element={<Inquiry />} /> {/** 문의 페이지 경로 수정 */}
            <Route path="/AdminGroups" element={<SuperAdminRoute><AdminGroups /></SuperAdminRoute>} /> {/** 관리자 그룹 관리. 2026-09-16 최고관리자 전용 */}
            <Route path="/AdminApprovals" element={<SuperAdminRoute><AdminApprovals /></SuperAdminRoute>} /> {/** 2026-09-16 관리자 가입 승인(최고관리자) */}
            <Route path="/AdminGroupRegister" element={<Navigate replace to="/AdminGroups" />} /> {/** 2026-09-14 관리자 그룹 관리로 합침(spec D1) */}
            <Route path="/AdminScreens" element={<SuperAdminRoute><AdminScreens /></SuperAdminRoute>} /> {/** 화면 권한 관리. 2026-09-16 최고관리자 전용 */}
            <Route path="/UserGroups" element={<UserGroups />} /> {/** 사용자 그룹 관리 페이지 */}
            <Route path="/UserGroupRegister" element={<Navigate replace to="/UserGroups" />} /> {/** 2026-09-14 사용자 그룹 관리로 합침(spec D2) */}
            <Route path="/DoctorManagement" element={<DoctorManagement />} /> {/** 주치의 관리 페이지 */}
            <Route path="/DoctorApplications" element={<DoctorApplications />} />
            <Route path="/TeleMedicine" element={<TeleMedicine />} />
            <Route path="/TeleMedicineVideo" element={<TeleMedicineVideo />} />
            <Route path="/kcb-auth-result" element={<KcbAuthResult />} />
            <Route path="/cert/raon/result" element={<RaonAuthResult />} />
            <Route path="/SafePackageList" element={<SafePackageList />} />
            <Route path="/UserWithdrawManagement" element={<UserWithdrawManagement />} />
            {/* 기관(병원) 마스터 관리. 메뉴에 노출하지 않고 주소로만 들어간다 —
                자주 쓰는 화면이 아니고, 잘못 건드리면 그룹·대상자가 참조하는
                마스터가 흔들린다. 화면 자체도 SUPER_ADMIN 만 통과시킨다. */}
            <Route path="/hos" element={<HospitalManagement />} />
            {/* 월간 보고서 발송 관리. 기관 관리와 같은 이유로 메뉴에 없다. SUPER_ADMIN 만. */}
            <Route path="/gro" element={<GroupReportOps />} />
            {/* 공지 푸시. 운영 관리 메뉴의 최고관리자 항목. 서버도 SUPER_ADMIN 만 통과시킨다. */}
            <Route path="/PushAnnouncements" element={<PushAnnouncements />} />
            <Route path="/health-report/:userId" element={<HealthReport />} />
            <Route path="/careplan/:userId" element={<CarePlan />} />
            <Route path="/survey/:userId" element={<Survey />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/auth/popup2" element={<CertSelect />} />
            <Route path="/cert/popup2" element={<CertSelect />} />
            <Route path="/cert/kcb/popup2" element={<KcbPopup />} />
            <Route path="/cert/raon/popup" element={<RaonPopup />} />
            <Route path="/cert/raon/popup2" element={<RaonPopup />} />
            <Route path="/comparison-chart-demo" element={<ComparisonChartDemo />} />
            <Route path="/PackagePurchaseManagement" element={<PackagePurchaseManagement />} />
            <Route path="/chat" element={<UserChat />} />
            {/** 설정된 경로를 제외한 나머지 경로로 접속한 경우 루트 페이지로 이동 */}
            <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
    );
}